<template>
  <vs-row vs-type="flex" vs-w="12" v-if="child != null && child.length > 0" class="pl-5 pt-1"
    style="overflow-x:hidden;">
    <vs-row vs-type="flex" vs-w="12" v-for="(variant) in child" :key="variant.id">
      <span @click="onClick(variant)" class="bg-secondary variant w-full flex">
        <vs-button v-if="variant.children != null && variant.children.length > 0" size="small" color="transparent p-0"
          class="text-primary" icon-pack="feather" :icon="variant.isExpand ? 'icon-minus' : 'icon-plus'"></vs-button>
        <p class="text-primary variant-name mr-5" :class="{'variant-expanded' : variant.isExpand}">
          {{variant.name}} - {{variant.type}}
          {{variant.price!=null?(" - "+ $toCurrency(variant.price)):("")}}
        </p>
        <vs-button v-if="variant.type!='Variant'" @click="addVariant(variant.id,variant.name)" size="medium" icon-pack="feather" icon="icon-plus"
          type="gradient" class="ml-5"></vs-button>
        <vs-button @click="deleteVariant(variant.id)" size="medium" icon-pack="feather" icon="icon-trash"
          color="danger" type="gradient" class="ml-2">
        </vs-button>
        <vs-button @click="editVariant(variant)" size="medium" icon-pack="feather" icon="icon-edit" color="secondary"
          type="gradient" class="ml-2">
        </vs-button>
        <!-- <vx-tooltip text="Şube Bazlı Fiyat Düzenleme" position="top">
        <vs-button v-if="variant.price!=null" @click="setBranchProductPrice(variant)" size="medium" icon-pack="feather" icon="icon-branches" color="secondary"
                   type="gradient" class="ml-2">
        </vs-button>
      </vx-tooltip> -->
      </span>
      <transition name="slide-fade">
        <parent-variant v-show="variant.isExpand" v-if="variant.children != null && variant.children.length > 0"
          :parent="variant.children" :parentRefs="parentRefsChild" />
      </transition>
    </vs-row>
  </vs-row>
</template>

<script>
  export default {
    props: {
      child: {
        type: Array,
        required: true
      },
      parentRefsChild: {
        type: Object,
        required: true
      }
    },
    components: {
      ParentVariant: () => import('./parentVariant.vue')
    },
    data() {
      return {
        showChildren: false,
      }
    },
    methods: {
      addVariant(rootVariantId, rootVariantName) {
        this.parentRefsChild.newVariantAdd.isActive = true;
        this.parentRefsChild.newVariantAdd.newVariant = {
          rootId: rootVariantId
        };
        this.parentRefsChild.newVariantAdd.rootName = rootVariantName;
      },
      onClick(variant) {
        variant.isExpand = !variant.isExpand;
      },
      deleteVariant(variantId) {
        this.parentRefsChild.newVariantAdd.deleteId = variantId;
      },
      editVariant(variant) {
        this.parentRefsChild.newVariantAdd.isActive = true;
        this.parentRefsChild.newVariantAdd.newVariant = _.cloneDeep(variant);
      },
      setBranchProductPrice(variant) {
        this.parentRefsChild.newBranchProductPrice.isActive = true;
        this.parentRefsChild.newBranchProductPrice.newPrice = _.cloneDeep(variant);
      }
    },
  }

</script>
